import React from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col, Button, Pagination } from 'antd';
import styles from './DeviceConfigItem.less';
import Remark from './Remark';
import Content from './Content';

@inject('deviceConfigStore')
@observer
class Configuration extends React.Component {
  render() {
    const { data } = this.props;
    const { showCopyModal } = this.props.deviceConfigStore;
    return (
      <div className={styles.configurationContainer}>
        <Row className={styles.rowContainer}>
          <span className={styles.title}>{data['configuration_name']}</span>{' '}
        </Row>
        <Row className={styles.rowContainer}>
          <Col span={6}>
            {' '}
            设备分组 :&nbsp;&nbsp;{data.tag
              ? data.tag['tag_name']
              : '分组已删除'}
          </Col>
          <Col span={6}> 配置下发时间 :&nbsp;&nbsp;{data['apply_time']}</Col>
          <Col span={2} offset={10}>
            <Button type="primary" onClick={() => showCopyModal(data)}>
              复制
            </Button>
          </Col>
        </Row>
        <Row className={styles.rowContainer}>
          <Remark disabled={data.status == '已下发'} data={data} />
        </Row>
        <Row className={styles.rowContainer}>
          <Content data={data} disabled={data.status == '已下发'} />
        </Row>
      </div>
    );
  }
}

export default Configuration;



// WEBPACK FOOTER //
// ./src/components/DeviceConfig/DeviceConfigItem.js